import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomerDocuments } from 'services/CustomerDocumentsService'

export const useGetCustomerDocuments = (customerReference: string) => {
  return useQuery({
    queryKey: reactQueryKeys.customerDocuments(customerReference),
    queryFn: () => getCustomerDocuments(customerReference),
    enabled: !!customerReference && customerReference !== undefined,
  })
}
